import React from "react";

export default function filter() {
  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Shop <span /> Fillter
            </div>
          </div>
        </div>
        <div className="container mb-30 mt-30">
          <div className="row">
            <div className="col-lg-12">
              <a className="shop-filter-toogle">
                <span className="fi-rs-filter mr-5" />
                Filters
                <i className="fi-rs-angle-small-down angle-down" />
                <i className="fi-rs-angle-small-up angle-up" />
              </a>
              <div className="shop-product-fillter-header">
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6 mb-lg-0 mb-md-2 mb-sm-2">
                    <div className="card">
                      <h5 className="mb-30">By Categories</h5>
                      <div className="categories-dropdown-wrap font-heading">
                        <ul>
                          <li>
                            <a>
                              <img
                                src="assets/imgs/theme/icons/category-1.svg"
                                alt=""
                              />
                              Milks and Dairies
                            </a>
                          </li>
                          <li>
                            <a>
                              <img
                                src="assets/imgs/theme/icons/category-2.svg"
                                alt=""
                              />
                              Clothing &amp; beauty
                            </a>
                          </li>
                          <li>
                            <a>
                              <img
                                src="assets/imgs/theme/icons/category-3.svg"
                                alt=""
                              />
                              Pet Foods &amp; Toy
                            </a>
                          </li>
                          <li className="mb-0">
                            <a>
                              <img
                                src="assets/imgs/theme/icons/category-4.svg"
                                alt=""
                              />
                              Baking material
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mb-lg-0 mb-md-2 mb-sm-2">
                    <div className="card">
                      <h5 className="mb-30">By Vendors</h5>
                      <div className="d-flex">
                        <div className="custome-checkbox mr-80">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox1"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox1"
                          >
                            <span>Aldi</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox2"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox2"
                          >
                            <span>Adidas</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox3"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox3"
                          >
                            <span>Burbe</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox4"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox4"
                          >
                            <span>Chanel</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox5"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox5"
                          >
                            <span>Prada</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox6"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox6"
                          >
                            <span>Kroger</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox7"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox7"
                          >
                            <span>Traders</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox8"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox8"
                          >
                            <span>Publix</span>
                          </label>
                        </div>
                        <div className="custome-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox11"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox11"
                          >
                            <span>Harris</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox21"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox21"
                          >
                            <span>Costco</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox31"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox31"
                          >
                            <span>Targets</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox41"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox41"
                          >
                            <span>Green Tea</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox51"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox51"
                          >
                            <span>iSnack</span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox61"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox61"
                          >
                            <span>Pambox</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mb-lg-0 mb-md-2 mb-sm-2">
                    <div className="card">
                      <h5 className="mb-30">By Tags</h5>
                      <div className="sidebar-widget widget-tags">
                        <ul className="tags-list">
                          <li className="hover-up">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Milk
                            </a>
                          </li>
                          <li className="hover-up">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Broccoli
                            </a>
                          </li>
                          <li className="hover-up">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Smoothie
                            </a>
                          </li>
                          <li className="hover-up">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Fruit
                            </a>
                          </li>
                          <li className="hover-up mr-0">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Salad
                            </a>
                          </li>
                          <li className="hover-up mr-0">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Appetizer
                            </a>
                          </li>
                          <li className="hover-up mr-0 mb-0">
                            <a>
                              <i className="fi-rs-cross mr-10" />
                              Appetizer
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6 mb-lg-0 mb-md-5 mb-sm-5">
                    <div className="card">
                      <h5 className="mb-10">By Price</h5>
                      <div className="sidebar-widget price_range range">
                        <div className="price-filter mb-20">
                          <div className="price-filter-inner">
                            <div id="slider-range" className="mb-20" />
                            <div className="d-flex justify-content-between">
                              <div className="caption">
                                From:
                                <strong
                                  id="slider-range-value1"
                                  className="text-brand"
                                />
                              </div>
                              <div className="caption">
                                To:
                                <strong
                                  id="slider-range-value2"
                                  className="text-brand"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="custome-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox211"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox211"
                          >
                            <span>Rs.0.00 - Rs.20.00 </span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox22"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox22"
                          >
                            <span>Rs.20.00 - Rs.40.00 </span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox23"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox23"
                          >
                            <span>Rs.40.00 - Rs.60.00 </span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox24"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox24"
                          >
                            <span>Rs.60.00 - Rs.80.00 </span>
                          </label>
                          <br />
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkbox"
                            id="exampleCheckbox25"
                            defaultValue=""
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleCheckbox25"
                          >
                            <span>Over Rs.100.00</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="shop-product-fillter">
                <div className="totall-product">
                  <p>
                    We found <strong className="text-brand">29</strong> items
                    for you!
                  </p>
                </div>
                <div className="sort-by-product-area">
                  <div className="sort-by-cover mr-10">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps" />
                          Show:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          {" "}
                          50 <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">50</a>
                        </li>
                        <li>
                          <a>100</a>
                        </li>
                        <li>
                          <a>150</a>
                        </li>
                        <li>
                          <a>200</a>
                        </li>
                        <li>
                          <a>All</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="sort-by-cover">
                    <div className="sort-by-product-wrap">
                      <div className="sort-by">
                        <span>
                          <i className="fi-rs-apps-sort" />
                          Sort by:
                        </span>
                      </div>
                      <div className="sort-by-dropdown-wrap">
                        <span>
                          Featured <i className="fi-rs-angle-small-down" />
                        </span>
                      </div>
                    </div>
                    <div className="sort-by-dropdown">
                      <ul>
                        <li>
                          <a className="active">Featured</a>
                        </li>
                        <li>
                          <a>Price: Low to High</a>
                        </li>
                        <li>
                          <a>Price: High to Low</a>
                        </li>
                        <li>
                          <a>Release Date</a>
                        </li>
                        <li>
                          <a>Avg. Rating</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row product-grid">
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe Naturel</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.28.85</span>
                          <span className="old-price">Rs.32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.52.85</span>
                          <span className="old-price">Rs.55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.48.85</span>
                          <span className="old-price">Rs.52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.17.85</span>
                          <span className="old-price">Rs.19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly Naturel</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.23.85</span>
                          <span className="old-price">Rs.25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.54.85</span>
                          <span className="old-price">Rs.55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.32.85</span>
                          <span className="old-price">Rs.33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.35.85</span>
                          <span className="old-price">Rs.37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.23.85</span>
                          <span className="old-price">Rs.25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.22.85</span>
                          <span className="old-price">Rs.24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-1-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-1-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Seeds of Change Organic Quinoe Naturel</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.28.85</span>
                          <span className="old-price">Rs.32.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-2-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-2-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>All Natural Italian-Style Chicken Meatballs</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "80%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (3.5)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Stouffer</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.52.85</span>
                          <span className="old-price">Rs.55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-3-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-3-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="new">New</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Angie’s Boomchickapop Sweet &amp; Salty</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "85%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>StarKist</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.48.85</span>
                          <span className="old-price">Rs.52.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-4-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-4-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Vegetables</a>
                      </div>
                      <h2>
                        <a>Foster Farms Takeout Crispy Classic</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.17.85</span>
                          <span className="old-price">Rs.19.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-5-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-5-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="best">-14%</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Pet Foods</a>
                      </div>
                      <h2>
                        <a>Blue Diamond Almonds Lightly natural</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.23.85</span>
                          <span className="old-price">Rs.25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-6-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-6-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Hodo Foods</a>
                      </div>
                      <h2>
                        <a>Chobani Complete Vanilla Greek Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.54.85</span>
                          <span className="old-price">Rs.55.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-7-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-7-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Meats</a>
                      </div>
                      <h2>
                        <a>Canada Dry Ginger Ale – 2 L Bottle</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.32.85</span>
                          <span className="old-price">Rs.33.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-8-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-8-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="sale">Sale</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Snack</a>
                      </div>
                      <h2>
                        <a>Encore Seafoods Stuffed Alaskan</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>NestFood</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.35.85</span>
                          <span className="old-price">Rs.37.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6">
                  <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-9-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-9-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                      <div className="product-badges product-badges-position product-badges-mrg">
                        <span className="hot">Hot</span>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Coffes</a>
                      </div>
                      <h2>
                        <a>Gorton’s Beer Battered Fish Fillets</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "90%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (4.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By
                          <a>Old El Paso</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.23.85</span>
                          <span className="old-price">Rs.25.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
                <div className="col-lg-1-5 col-md-4 col-12 col-sm-6 d-none d-xl-block">
                  <div className="product-cart-wrap">
                    <div className="product-img-action-wrap">
                      <div className="product-img product-img-zoom">
                        <a>
                          <img
                            className="default-img"
                            src="assets/imgs/shop/product-10-1.jpg"
                            alt=""
                          />
                          <img
                            className="hover-img"
                            src="assets/imgs/shop/product-10-2.jpg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="product-action-1">
                        <a aria-label="Add To Wishlist" className="action-btn">
                          <i className="fi-rs-heart" />
                        </a>
                        <a aria-label="Compare" className="action-btn">
                          <i className="fi-rs-shuffle" />
                        </a>
                        <a
                          aria-label="Quick view"
                          className="action-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#quickViewModal"
                        >
                          <i className="fi-rs-eye" />
                        </a>
                      </div>
                    </div>
                    <div className="product-content-wrap">
                      <div className="product-category">
                        <a>Cream</a>
                      </div>
                      <h2>
                        <a>Haagen-Dazs Caramel Cone Ice Cream</a>
                      </h2>
                      <div className="product-rate-cover">
                        <div className="product-rate d-inline-block">
                          <div
                            className="product-rating"
                            style={{ width: "50%" }}
                          />
                        </div>
                        <span className="font-small ml-5 text-muted">
                          {" "}
                          (2.0)
                        </span>
                      </div>
                      <div>
                        <span className="font-small text-muted">
                          By <a>Tyson</a>
                        </span>
                      </div>
                      <div className="product-card-bottom">
                        <div className="product-price">
                          <span>Rs.22.85</span>
                          <span className="old-price">Rs.24.8</span>
                        </div>
                        <div className="add-cart">
                          <a className="add">
                            <i className="fi-rs-shopping-cart mr-5" />
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*end product card*/}
              </div>
              {/*product grid*/}
              <div className="pagination-area mt-20 mb-20">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-start">
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-left" />
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">1</a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link dot">...</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">6</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link">
                        <i className="fi-rs-arrow-small-right" />
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <section className="section-padding pb-5">
                <div className="section-title">
                  <h3 className="">Deals Of The Day</h3>
                  <a className="show-all">
                    All Deals
                    <i className="fi-rs-angle-right" />
                  </a>
                </div>
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-5.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2025/03/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Seeds of Change Organic Quinoa, Brown</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "90%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (4.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>NestFood</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>Rs.32.85</span>
                              <span className="old-price">Rs.33.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-6.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2026/04/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Perdue Simply Smart Organics Gluten</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "90%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (4.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Old El Paso</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>Rs.24.85</span>
                              <span className="old-price">Rs.26.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 d-none d-lg-block">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-7.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2027/03/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Signature Wood-Fired Mushroom</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "80%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (3.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Progresso</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>Rs.12.85</span>
                              <span className="old-price">Rs.13.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-4 col-md-6 d-none d-xl-block">
                    <div className="product-cart-wrap style-2">
                      <div className="product-img-action-wrap">
                        <div className="product-img">
                          <a>
                            <img src="assets/imgs/banner/banner-8.png" alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="product-content-wrap">
                        <div className="deals-countdown-wrap">
                          <div
                            className="deals-countdown"
                            data-countdown="2025/02/25 00:00:00"
                          />
                        </div>
                        <div className="deals-content">
                          <h2>
                            <a>Simply Lemonade with Raspberry Juice</a>
                          </h2>
                          <div className="product-rate-cover">
                            <div className="product-rate d-inline-block">
                              <div
                                className="product-rating"
                                style={{ width: "80%" }}
                              />
                            </div>
                            <span className="font-small ml-5 text-muted">
                              {" "}
                              (3.0)
                            </span>
                          </div>
                          <div>
                            <span className="font-small text-muted">
                              By
                              <a>Yoplait</a>
                            </span>
                          </div>
                          <div className="product-card-bottom">
                            <div className="product-price">
                              <span>Rs.15.85</span>
                              <span className="old-price">Rs.16.8</span>
                            </div>
                            <div className="add-cart">
                              <a className="add">
                                <i className="fi-rs-shopping-cart mr-5" />
                                Add
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/*End Deals*/}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
